import axios, { AxiosRequestConfig, ResponseType } from 'axios';
import Config from "../config";
import { AxiosInstance } from "../helpers/AxiosInstance";
import { HmacSignatureUtilities } from './hmac-encryption-decryption';

const getAllSecureFiles = (id: any) => {
    return AxiosInstance.post(`${Config.API_SECOND_URL}/securefileshare/api/v1/completefilesList`, id);
}

const getFaceStatusFiles = (organizationId) => {
    return AxiosInstance.get(`${Config.API_SECOND_URL}/securefileshare/api/v1/faceStatus/org/${organizationId}`);
}

const deleteSecureFile = (data: any) => {
    return AxiosInstance.delete(`${Config.API_SECOND_URL}/securefileshare/api/v1/deleteFile`, { data })
}

const getSelectedFile = (data: any) => {
    return AxiosInstance.post(`${Config.API_SECOND_URL}/securefileshare/api/v1/fileDetails`, data)
}

const downloadSecureFile = (data: any) => {
    const config: AxiosRequestConfig = {
        responseType: 'arraybuffer' as ResponseType
    };

    return AxiosInstance.post(`${Config.API_SECOND_URL}/securefileshare/api/v1/downloadFile`, data, config);
}

const getUrlLink = (data: any) => {
    return AxiosInstance.post(`${Config.API_SECOND_URL}/securefileshare/api/v1/getFileURL`, data)
}

const getFileAccessList = (data: any) => {
    return AxiosInstance.post(`${Config.API_SECOND_URL}/securefileshare/api/v1/getFileAccessList`, data)
}

const removeFillAccess = (data: any) => {
    return AxiosInstance.post(`${Config.API_SECOND_URL}/securefileshare/api/v1/manageFileAccess`, data)
}

const addFillAccess = (data: any) => {
    return AxiosInstance.post(`${Config.API_SECOND_URL}/securefileshare/api/v1/manageFileAccess`, data)
}

const uploadFile = (data: any) => {
    return AxiosInstance.post(`${Config.API_SECOND_URL}/securefileshare/api/v1/uploadFile`, data)
}

const verifyEmail = (data: any) => {
    return axios.post(`${Config.API_SECOND_URL}/securefileshare/api/v1/verifyEmail`, data, { headers: { FalkonSignature: HmacSignatureUtilities.signData(data) } })
}

const verifyOTP = (data: any) => {
    const config: AxiosRequestConfig = {
        responseType: 'arraybuffer' as ResponseType,
        headers: { FalkonSignature: HmacSignatureUtilities.signData(data) }
    };
    return axios.post(`${Config.API_SECOND_URL}/securefileshare/api/v1/verifyOTP`, data, config)
}

const getAllSecureFileNameAndLinks = (data: any) => {
    return AxiosInstance.post(`${Config.API_SECOND_URL}/securefileshare/api/v1/concisefilesList`, data)
}

const FaceRegistrationInvitationStatus = (contactId: any) => {
    return AxiosInstance.get(`${Config.API_SECOND_URL}/securefileshare/api/v1/faceStatus/${contactId}`)
}

const faceRegister = (data) => {
    return axios.post(`${Config.API_SECOND_URL}/securefileshare/api/v1/register`, data, { headers: { FalkonSignature: HmacSignatureUtilities.signData(data) } })
}

const ValidateRegisterlink = (id: string) => {
    return axios.post(`${Config.API_SECOND_URL}/securefileshare/api/v1/validate/${id}`)
}

const getSessionId = (id: { id: string }) => {
    return axios.post(`${Config.API_SECOND_URL}/securefileshare/api/v1/session`, id, { headers: { FalkonSignature: HmacSignatureUtilities.signData(id) } })
}

const VerifySecureFaceFile = (data) => {
    const config: AxiosRequestConfig = {
        responseType: 'arraybuffer' as ResponseType,
        headers: { FalkonSignature: HmacSignatureUtilities.signData(data) }
    }
    return axios.post(`${Config.API_SECOND_URL}/securefileshare/api/v1/unlock`, data, config)
}

const editInviteConatctName = (data: any) => {
    return AxiosInstance.put(`${Config.API_SECOND_URL}/securefileshare/api/v1/updateContactDetails`, data)
}

const deleteInviteLinks = (orgId: string, data: any) => {
    return AxiosInstance.delete(`${Config.API_SECOND_URL}/securefileshare/api/v1/face/org/${orgId}`, { data })
}

const massActionSendInvite = (orgId: string, data: any) => {
    return AxiosInstance.post(`${Config.API_SECOND_URL}/securefileshare/api/v1/invite/bulk/${orgId}`, data)
}

const SecureFilesMassDelete = (data:any) =>{    
    return AxiosInstance.delete(`${Config.API_SECOND_URL}/securefileshare/api/v1/deleteFiles`,{data})
}


export const SecureFileService = {
    getAllSecureFiles,
    getFaceStatusFiles,
    deleteSecureFile,
    getSelectedFile,
    downloadSecureFile,
    getUrlLink,
    getFileAccessList,
    removeFillAccess,
    addFillAccess,
    uploadFile,
    verifyEmail,
    verifyOTP,
    getAllSecureFileNameAndLinks,
    FaceRegistrationInvitationStatus,
    faceRegister,
    ValidateRegisterlink,
    getSessionId,
    VerifySecureFaceFile,
    editInviteConatctName,
    deleteInviteLinks,
    massActionSendInvite,
    SecureFilesMassDelete,
}